<template>
	<ModalHeader
		:title="getString('chosen_font')"
		:button-text="getString('save')"
		@click-button="saveClicked" />
	<div class="wrapper-text-input">
		<AppTextInput :placeholder="getString('test_the_font')" @input="updateFont" />
	</div>
	<div class="wrapper-font-list">
		<div class="font-selector" v-for="(font, index) in fonts" :key="index" :class="{ active: font.name === userStore.currBusiness.custom_font.replaceAll(' ', '') }" @click="setFont(font)">
			<p class="font-label">{{ font.name }}</p>
			<div class="wrapper-text-gradient">
				<p class="font-example font-example-title" :style="{ 'font-family': font.name }">{{ inputFont || font.name }}</p>
				<p class="font-example font-example-subtitle" :style="{ 'font-family': font.name }">{{ inputFont || font.name }}</p>
			</div>
		</div>
	</div>
</template>

<script>

import AppTextInput from "@/shared/components/AppTextInput.vue";
import ModalHeader from "@/console-new/components/shared/ModalHeader.vue";
import {useLanguageStore, useNotificationStore} from "@/shared/stores";
import {useUserStore} from "@/console-new/stores";
import {usePdfStore} from "@/pdf/stores";
const baseUrl = "https://img.qromo.io/fonts/";

export default {
	setup() {
		let languageStore = useLanguageStore();
		let userStore = useUserStore();
		let pdfStore = usePdfStore();
		return {
			getString: languageStore.getString,
			userStore,
			pdfStore,
		};
	},
	name: "FontChooser",
	emits: ["save-clicked"],
	components: {
		ModalHeader,
		AppTextInput,
	},
	data() {
		return {
			inputFont: '',
		}
	},
	computed: {
		fonts() {
			return this.pdfStore.getFonts();
		}
	},
	methods: {
		setFont(font) {
			this.userStore.currBusiness.custom_font = font.name;
		},
		saveClicked() {
			this.$emit("save-clicked");
		},
		updateFont(event) {
			this.inputFont = event.target.value;
		},
		loadFonts() {

			let oldCss = document.querySelector('style[data-fonts-dload]');
			if (oldCss) {
				//already loaded
				return;
			}

			let css = document.createElement('style');
			this.fonts.forEach(font => {
				Object.entries(font.weight).forEach(([weight, fontData]) => {
					css.innerHTML += `@font-face {
					font-family: '${font.name}';
					font-style: normal;
					font-weight: ${fontData.style};
					src: url('${baseUrl}${fontData.name}') format('woff2');
				}`;
				});
			});

			css.setAttribute('data-fonts-dload', '');
			document.head.appendChild(css);
		},
	},
	mounted() {
		this.loadFonts();
	}
}
</script>

<style scoped lang="scss">
.wrapper-font-list {
	display: flex;
	flex-wrap: wrap;
	gap: 10px 40px;
	@media (max-width: 1080px) {
		gap: 5px;
	}
	.font-selector {
		display: flex;
		flex-direction: column;
		border-radius: 0;
		border-bottom: 1px solid $alpha_2;
		border-top: 1px solid transparent;
		border-left: 1px solid transparent;
		border-right: 1px solid transparent;
		padding: 10px;
		gap: 10px;
		cursor: pointer;
		flex: 0 0 50%;
		max-width: calc(50% - 20px);
		@media (max-width: 1080px) {
			flex: 0 0 100%;
			max-width: 100%;
		}
		.font-example {

			&.font-example-title {
				font-weight: 700;
				font-size: 28px;
				line-height: 38px;
			}

			&.font-example-subtitle {
				font-size: 18px;
				font-weight: 400;
			}
		}
		.wrapper-text-gradient {
			position: relative;
			&:before {
				content: "";
				position: absolute;
				top: 0;
				right: 0;
				width: 100%;
				height: 100%;
				background: linear-gradient(90deg, rgba(var(--rgb-bg-primary-1), 0) 90%, rgba(var(--rgb-bg-primary-1), 1) 100%);
			}
			p {
				float:left;
				overflow:hidden;
				white-space: nowrap;
				width: 100%;
			}
		}
		&:hover {
			background-color: var(--color-bg-primary-2);
			border: 1px solid transparent;
			border-radius: 13px;
			.wrapper-text-gradient {
				&:before {
					content: "";
					position: absolute;
					top: 0;
					right: 0;
					width: 100%;
					height: 100%;
					transition: all 0.28s ease-in-out;
					background: linear-gradient(90deg, rgba(var(--rgb-bg-primary-2), 0) 90%, rgba(var(--rgb-bg-primary-2), 1) 100%);
				}
			}
		}
		&.active {
			border-radius: 13px;
			background-color: var(--color-bg-primary-2);
			border: 1px solid var(--color-primary);
			.wrapper-text-gradient {
				&:before {
					content: "";
					position: absolute;
					top: 0;
					right: 0;
					width: 100%;
					height: 100%;
					transition: all 0.28s ease-in-out;
					background: linear-gradient(90deg, rgba(var(--rgb-bg-primary-2), 0) 90%, rgba(var(--rgb-bg-primary-2), 1) 100%);
				}
			}
		}
	}
}
.wrapper-text-input {
	width: 100%;
	padding: 20px;
	background-color: $alpha_1;
	box-shadow: inset 0 1px 2px $alpha_4;
	border-radius: 13px;
	margin-bottom: 10px;
}
:deep(.input-wrapper) {
	width: 100%;
	.input-element input {
		height: 70px;
		font-size: 30px;
		line-height: 40px;
	}
}
</style>